// extracted by mini-css-extract-plugin
export default {"grade":"Skeleton_grade__Ii85r","lista":"Skeleton_lista__lE4ij","bloco":"Skeleton_bloco__o07Ah","pulso":"Skeleton_pulso__yy4ze"};